import { Flex, Grid, Heading, Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { menuGroups, socials } from '../constants';
import { LegalMenu } from './LegalMenu';
import { MenuGroup } from './MenuGroup';
import { SocialButton } from './SocialButton';

interface IFullFooterProps {}

export const FullFooter: React.FC<IFullFooterProps> = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Flex alignItems={{ base: 'center', md: 'flex-start' }}>
        <Link href="/" w="full">
          <img alt="MBE Auction" height={58} src="/images/logo.png" title="MBE" width={340} />
        </Link>
      </Flex>
      <Grid
        gap={{ base: 8, md: 24, lg: 32, xl: 52 }}
        py={{ base: 12, md: 24 }}
        templateColumns={{ base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }}
      >
        {menuGroups.map(({ heading, items }, i) => (
          <MenuGroup
            heading={t(heading)}
            items={items.map((el) => ({ ...el, label: t(el.label) }))}
            key={`group-menu-${i}`}
          />
        ))}
        <Flex direction="column" gap={4}>
          <Heading fontSize={{ base: 'large', md: 'h4' }} fontWeight="medium">
            {t('LANDING.FOOTER.FOLLOW_US')}
          </Heading>
          <Flex
            flexWrap="wrap"
            gap={2}
            justifyContent="flex-start"
            w={{ base: 'full', sm: 'auto' }}
          >
            {socials.map((social) => (
              <SocialButton
                border="1px"
                borderColor="brand.black"
                color="brand.black"
                href={social.href}
                key={`menuItem-${social.id}`}
                label={social.label}
              >
                <social.icon />
              </SocialButton>
            ))}
          </Flex>
        </Flex>
      </Grid>
      <LegalMenu />
    </>
  );
};
